import React from "react";
import SubscribeNowPopup from "../components/SubscribeNowPopup";
import {
  SetSessionPopupShown,
  GetLocalHasSubscribed,
  GetSessionPopupShown,
  SetPopupStartTime,
  GetPopupStartTime,
} from "../components/WebStorage";

interface SubscribePopup {
  backgroundColor?: string;
  backgroundImage?: string;
  content?: string;
  fontColor?: string;
  title?: string;
  contentAlignment?: any;
  isBackgroundGradient?: boolean;
  popupCTA?: Link;
}

interface Link {
  name: string;
  target: string;
  url: string;
  size?: string;
  format?: string;
}

interface State {
  isPopupActive: boolean;
  subscribeNowPopUpValues: SubscribePopup | null;
}

class SubscribeNowPopupContainer extends React.Component<{}, State> {
  private popupTimer?: number;

  constructor(props: {}) {
    super(props);
    this.state = {
      isPopupActive: false,
      subscribeNowPopUpValues: null,
    };
  }

  componentDidMount(): void {
    SetPopupStartTime();
    const startTime = GetPopupStartTime();
    const elapsed = Date.now() - startTime;

    const windowValues = (window as any)["SubscribePopupModel"] as
      | SubscribePopup
      | undefined;
    if (windowValues) this.setState({ subscribeNowPopUpValues: windowValues });

    // Skip if already shown or subscribed
    if (GetSessionPopupShown() || GetLocalHasSubscribed()) return;

    const blockedPaths = [
      "/contact-us",
      "/fleet",
      "/value-my-car",
      "/buy-online",
      "/service-booking",
      "/dealers",
      "/book-a-test-drive",
      "/brochure-download",
      "/special-offers",
      "/configure",
    ];
    const currentPath = window.location.pathname.toLowerCase();
    const isBlocked = blockedPaths.some((p) =>
      currentPath.startsWith(p.toLowerCase())
    );
    if (isBlocked) return;

    const delay = 60999;
    if (elapsed >= delay) {
      this.activatePopup();
    } else {
      this.startPopupTimer(delay - elapsed);
    }
  }

  componentWillUnmount(): void {
    if (this.popupTimer) clearTimeout(this.popupTimer);
  }

  startPopupTimer = (delay: number) => {
    this.popupTimer = window.setTimeout(this.doWeActivatePopup, delay);
  };

  doWeActivatePopup = () => {
    if (!GetSessionPopupShown() && !GetLocalHasSubscribed()) {
      this.activatePopup();
    }
  };

  activatePopup = () => {
    if (!this.state.isPopupActive) {
      this.setState({ isPopupActive: true }, () => {
        SetSessionPopupShown();
      });
    }
  };

  deActivatePopup = () => {
    if (this.state.isPopupActive) {
      this.setState({ isPopupActive: false });
      SetSessionPopupShown();
    }
  };

  render() {
    if (!this.state.subscribeNowPopUpValues) {
      return null;
    }

    const {
      backgroundColor,
      backgroundImage,
      content,
      fontColor,
      title,
      contentAlignment,
      isBackgroundGradient,
      popupCTA,
    } = this.state.subscribeNowPopUpValues;

    return (
      <SubscribeNowPopup
        backgroundColor={backgroundColor}
        backgroundImage={backgroundImage}
        content={content}
        contentAlignment={contentAlignment}
        fontColor={fontColor}
        title={title}
        isActive={this.state.isPopupActive}
        isBackgroundGradient={isBackgroundGradient}
        popupCTA={popupCTA}
        deActivatePopup={this.deActivatePopup}
      />
    );
  }
}

export default SubscribeNowPopupContainer;
